import serviceHandler from "@/helpers/handlers/service";
import usersService from "@/services/users";
import { GMBWithComparisionDataBase } from "./gmb-with-comparision-data-base";

export class GMBWithComparisionDataUpdated extends GMBWithComparisionDataBase {
  async _getGMBDataFromApi(apiPayload) {
    return await serviceHandler(usersService.getGoogleInsights(apiPayload));
  }

  async _getExportedFileFromApi(apiPayload, params) {
    return await serviceHandler(
      usersService.getGoogleInsights(apiPayload, params)
    );
  }

  async _getExportedFileFromApiAsync(apiPayload, params) {
    return await serviceHandler(
      usersService.getGoogleInsightsAsync(apiPayload, params)
    );
  }
}
